var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-rating',{attrs:{"background-color":"orange darken-2","color":"orange darken-2","length":"5","hover":"","dense":_vm.$vuetify.breakpoint.xsOnly},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }